module.exports = __webpack_public_path__ + "images/emoji/soccer.cd3309a5b6214fbe2896.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/soccer.png
// module id = ExqZ
// module chunks = 13